import React, { useState, useEffect } from "react";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import Divider from "@mui/material/Divider";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Video from "../Video/video";
import { obtenerPlayListVideo } from "../Services/youtubeServices";

const Lista = ({ lista }) => {
  const [videos, setVideos] = useState([]);
  //const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    cargarPlayListVideo();
    //console.log(lista);
  }, []);

  const cargarPlayListVideo = async () => {
    const { data: videos } = await obtenerPlayListVideo(lista.id);
    setVideos(videos.items);
    //setLoading(false);
    //console.log(videos);
  };
  return (
    <Container>
      <h3>{lista.snippet.title}</h3>
      <Grid container spacing={5}>
        {videos.length > 0 &&
          videos.map((video) => <Video video={video} key={video.id}></Video>)}
      </Grid>
      <Divider />
    </Container>
  );
};

export default Lista;
